import "./styles/globals.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import { MsalProvider } from "@azure/msal-react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import MsalInstance from "./services/authClient";

async function initMsal() {
	await MsalInstance.initialize();
}

initMsal();

const root = createRoot(document.getElementById("root") as HTMLElement);

const queryClient = new QueryClient({
	defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } }
});

const appInsightsConnString = window._env_.REACT_APP_AI_CONNSTRING;

if (appInsightsConnString) {
	const appInsights = new ApplicationInsights({
		config: {
			connectionString: appInsightsConnString.replace("%3D", "=") // we have to escape the = because of how we load in the vars at build time,
		}
	});
	appInsights.loadAppInsights();
	appInsights.trackPageView(); // This only tacks a full page load, no react routing
}

root.render(
	<BrowserRouter basename={window._env_.PUBLIC_URL}>
		<QueryClientProvider client={queryClient}>
			<MsalProvider instance={MsalInstance}>
				<App />
			</MsalProvider>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	</BrowserRouter>
);
